import { CampoDaConsulta, bareInputCls } from "./CampoDaConsulta";
import type { SalaDaOpcao } from "./use-sala-da-consulta";

/** Campo "Sala": só aparece quando a clínica tem salas. Vem com a sala do profissional no dia. */
export function SalaDaConsulta({ salas, valor, onChange }: { salas: SalaDaOpcao[]; valor: string | null; onChange: (id: string) => void }) {
  if (!salas.length) return null;
  const atual = salas.find((s) => s.id === valor);
  return (
    <CampoDaConsulta label="Sala">
      <span className="flex items-center gap-2">
        <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ backgroundColor: atual?.cor ?? "#d4d4d8" }} />
        <select className={`${bareInputCls} cursor-pointer`} value={valor ?? ""} onChange={(e) => onChange(e.target.value)}>
          <option value="">Sem sala</option>
          {salas.map((s) => (
            <option key={s.id} value={s.id}>
              {s.nome}
            </option>
          ))}
        </select>
      </span>
    </CampoDaConsulta>
  );
}
